module.exports = __webpack_public_path__ + "img/filter_icon.e92b2bc8.svg";